import { render, staticRenderFns } from "./LaskuriviTable.vue?vue&type=template&id=392a946c&scoped=true&"
import script from "./LaskuriviTable.vue?vue&type=script&lang=js&"
export * from "./LaskuriviTable.vue?vue&type=script&lang=js&"
import style0 from "./LaskuriviTable.vue?vue&type=style&index=0&id=392a946c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392a946c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VForm,VIcon,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('392a946c')) {
      api.createRecord('392a946c', component.options)
    } else {
      api.reload('392a946c', component.options)
    }
    module.hot.accept("./LaskuriviTable.vue?vue&type=template&id=392a946c&scoped=true&", function () {
      api.rerender('392a946c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LaskuriviTable.vue"
export default component.exports